import React, {useEffect, useRef, useState} from "react";
import {makeStyles} from "@material-ui/core/styles";
import {Collapse} from "@material-ui/core";
import Alert from '@material-ui/lab/Alert';
import IconButton from "@material-ui/core/IconButton";
import AlertTitle from "@material-ui/lab/AlertTitle";
import LinearProgress from "@material-ui/core/LinearProgress";

const useStyles = makeStyles(theme => ({
    root: {
        margin: '0px 0px 10px 0px',
    },
    title: {
        fontSize: '14px'
    },
    message: {
        fontSize: '12px',
        margin:'0',
        padding:'0',
    },
    progress: {
        width: '100%',
        marginTop:'-15px',
        marginBottom:'10px'
    },
}));

function usePrevious(value) {
    const ref = useRef();
    useEffect(() => { ref.current = value});
    return ref.current
};

export default function InfoBoxes({alert, index}){
    const [open, setOpen] = useState(true);
    const prevAlert = usePrevious(alert);
    const classes = useStyles();
    const timer = (delay)=> {
        setTimeout(() => { setOpen(false); }, delay);
    };

    useEffect(() => {
        if(prevAlert !== alert) {
            setOpen(true);
        }
    }, [alert,prevAlert]);

    return (
        <>
            <Collapse in={open}>
                <Alert
                    key={index}
                    className={classes.root}
                    severity={alert.type}
                    action={
                        !alert.disableClose &&
                        <IconButton
                            aria-label="close"
                            color="inherit"
                            size="small"
                            onClick={() => { setOpen(false); }}
                        >
                            <span className="icon-cancel"></span>
                        </IconButton>
                    }
                >
                    <AlertTitle className={classes.title}>{alert.title}</AlertTitle>
                    <p className={classes.message}>{alert.message}</p>
                </Alert>
                {alert.progress && <LinearProgress className={classes.progress} />}
                {alert.timer && timer(alert.timer)}
            </Collapse>
        </>
    )


};